import { render, staticRenderFns } from "./OfficialHolidaysPlanDetailsDelete.vue?vue&type=template&id=3825320c&scoped=true&"
import script from "./OfficialHolidaysPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825320c",
  null
  
)

export default component.exports